/* eslint-disable no-underscore-dangle, no-undef */
require('./emile.min.js');

const pubsub = window.DR.pubsub;

/**
 * Renders responsive images
 * @returns {void}
 */
function responsiveImages() {

  const responsiveImgs = document.querySelectorAll('img.respImg');
  let i = 0;

  /**
   * Shows small image if it hasn't been already shown.
   * Replaces src attr of <img> with value of data-small attr
   *
   * @param imgElement DOM <img> element
   */
  function showSmallImage(imgElement) {
    // checking if small image hasn't been already shown
    if (imgElement.hasAttribute('data-small') &&
      (imgElement.getAttribute('src') !== imgElement.getAttribute('data-small'))) {
      imgElement.setAttribute('src', imgElement.getAttribute('data-small'));

      imgElement.className = `respImg image${
        imgElement.className.indexOf('product-image') !== -1 ? 'product-image' : ''}`;
    }
  }

  /**
   * Shows big image if it hasn't been already shown.
   * Replaces src attr of <img> with value of data-big attr.
   * At the beginning it stores src attr value of small image to data-small attr,
   * if this attr hasn't been already fulfilled
   *
   * @param imgElement DOM <img> element
   */
  function showBigImage(imgElement) {
    // src of small image has to be added to data-small attributte for the first time
    // when switching from small image to big image
    if (!imgElement.hasAttribute('data-small')) {
      imgElement.setAttribute('data-small', imgElement.getAttribute('src'));
    }

    // checking if big image hasn't been already shown
    if (imgElement.getAttribute('src') !== imgElement.getAttribute('data-big')) {
      imgElement.setAttribute('src', imgElement.getAttribute('data-big'));

      imgElement.className = `image imageDesk${
        imgElement.className.indexOf('product-image') !== -1 ? 'product-image' : ''}`;
    }
  }

  /**
   * Sets the url of image link
   * @param {HTMLElement} img
   * @param {string} url
   * @returns {void}
   */
  function setLinkHref(imgElement) {
    const link = $(imgElement).closest('a');
    if (link.length > 0 && link[0] !== null && link.attr('href').toLowerCase().indexOf('jpg') > 0) {
      link.attr('href', imgElement.getAttribute('src'));
    }
  }

  pubsub.on('resize', (dims) => {
    if (dims.width > 599) {
      for (i = 0; i < responsiveImgs.length; i++) {
        showBigImage(responsiveImgs.item(i));
        setLinkHref(responsiveImgs.item(i));
      }
    } else {
      for (i = 0; i < responsiveImgs.length; i++) {
        showSmallImage(responsiveImgs.item(i));
        setLinkHref(responsiveImgs.item(i));
      }
    }
  });

  if (window.matchMedia('(min-width: 599px)').matches) {
    for (i = 0; i < responsiveImgs.length; i++) {
      showBigImage(responsiveImgs.item(i));
      setLinkHref(responsiveImgs.item(i));
    }
  }
}

function responsiveContent(className) {

  const contentItems = [];
  const sections = $(`.${className}`);

  sections.each(function callback() {
    const $this = $(this);
    contentItems.push({
      elt: $this,
      url: $this.attr('data-ajax')
    });
  });

  function _loadContent(obj) {
    obj.loader = $('<div class="loading desktop"><span></span> Loading\u2026</div>');
    obj.loader.insertBefore(obj.elt);
    obj.init = true;

    $.ajax({
      url: obj.url,
      type: 'json',
      dataType: 'json',
      success: function(resp) {
        obj.pH = $(`<section class="respContent">${resp.content}</section>`).insertAfter(obj.elt);
        obj.pH[0].id = $(obj.elt)[0].id;
        obj.elt.remove();
        obj.loader.remove();

        obj.pH.css({ display: 'block', opacity: 0 });
        emile(obj.pH[0], 'opacity:1', { duration: 150 });

      }
    });
  }

  function _init(width) {

    if (width > 599) {
      $(contentItems).each(function callback() {
        if (!this.init) { _loadContent(this); }
      });
    }
  }

  pubsub.on('resize', _init);
  _init($(window).width());

}

export const initResponsiveImages = () => responsiveImages();
export const initResponsiveContent = () => responsiveContent('respContent');
